function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_146433",
  d: "M16.915,28.566a12.078,12.078,0,0,1-12.012-12,12.006,12.006,0,1,1,12.012,12Zm6.232-12.012a1.1,1.1,0,0,0-.406-.859l-4.1-4.039a1.009,1.009,0,0,0-1.718.708,1.063,1.063,0,0,0,.313.743L18.691,14.5l1.358,1.079-2.472-.116H11.716a1.1,1.1,0,0,0,0,2.194h5.861l2.472-.116L18.7,18.621,17.24,20.013a1.016,1.016,0,0,0-.313.743.963.963,0,0,0,.986,1.01,1.018,1.018,0,0,0,.731-.3l4.1-4.027A1.148,1.148,0,0,0,23.147,16.555Z",
  transform: "translate(-4.903 -4.566)",
  fill: "currentColor"
});

function SvgFillArrowBack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.012,
    height: 24,
    viewBox: "0 0 24.012 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFillArrowBack);
export default __webpack_public_path__ + "static/media/fill-arrow-back.d39a03a0.svg";
export { ForwardRef as ReactComponent };